module.exports = __webpack_public_path__ + "static/media/fine-tune.51632784.svg";